import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Keyboard } from 'swiper';
import { formatImageWebpAuto } from '@ifeng-fe/public_method';
import 'swiper/css';
import Style from './index.css';

const Page3 = (props) => {
    const { peopleList, peopleIndex, onChangePeopleIndex } = props;

    return (
        <div className={Style.page2}>
            <div className={Style.swiperWp}>
                <img className={Style.navigation} id="page3_prev" src={require('@src/common/assets/prev2.png')} alt="" />

                <Swiper
                    key={peopleIndex}
                    modules={[Navigation, Pagination, Keyboard]}
                    className={Style.swiper}
                    speed={1500}
                    navigation={{
                        prevEl: '#page3_prev',
                        nextEl: '#page3_next',
                    }}
                    pagination={{
                        el: `.${Style.pagination}`,
                        type: 'fraction',
                    }}
                    keyboard={{
                        enabled: true,
                    }}>
                    {peopleList[peopleIndex]?.imageList.map((image, index) => {
                        return (
                            <SwiperSlide key={index}>
                                <div className={Style.swiperItem}>
                                    <img src={formatImageWebpAuto(image, 1118, 629)} alt="" />
                                </div>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>

                <img className={Style.navigation} id="page3_next" src={require('@src/common/assets/next2.png')} alt="" />

                <div className={Style.pagination} />
            </div>

            <div className={Style.peopleList}>
                {peopleList.map((people, index) => {
                    return (
                        <div key={index}>
                            <div className={`${Style.people} ${index === peopleIndex ? Style.active : ''}`} onClick={() => onChangePeopleIndex(index)}>
                                {people.name}
                            </div>
                            {index < peopleList.length - 1 && <span className={Style.divider}>/</span>}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

Page3.propTypes = {
    peopleList: PropTypes.array,
    peopleIndex: PropTypes.number,
    onChangePeopleIndex: PropTypes.func,
};

export default errorBoundary(Page3);
